export default {"src":"/_next/static/media/LRCX.b7aa56cf.svg","height":18,"width":18};